import React, { useRef, useEffect, useState, useContext } from "react";
import axios from 'axios';
import './Modal.css';
import { Context } from "../../context";
import { ReactComponent as Close } from '../../svg/close.svg';
const ip = process.env.REACT_APP_IP;

function ModalNouveauSort({ isOpen, idPerso, setOpen, setModif, sort,token }) {

    const { fetchPersonnage } = useContext(Context);
    const [nomSort, setNomSort] = useState("");
    const [descriptionSort, setDescriptionSort] = useState("");
    const [effetSort, setEffetSort] = useState("");
    const [coutSort, setCoutSort] = useState("");
    const [niveausort, setNiveauSort] = useState(1);
    useEffect(() => {
        if (sort) {
            setNomSort(sort.nom);
            setDescriptionSort(sort.description);
            setEffetSort(sort.effet);
            setCoutSort(sort.cout);
        } else {
            setNomSort("");
            setDescriptionSort("");
            setEffetSort("");
            setCoutSort("");
        }
    }, [sort]);
    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setModif(false)
                    setOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    console.log("sort : " + isOpen)
    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (nomSort === "" || effetSort === "" || descriptionSort === "" || coutSort === "") {
            console.log("Tous les champs doivent être remplis");
        } else {
            try {
                if (sort) {
                    await axios.put(`${ip}/sort/${sort.idSort}`, {
                        idPerso,
                        nomSort,
                        descriptionSort,
                        effetSort,
                        coutSort,
                        niveausort
                    }, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    });
                } else {
                    await axios.post(`${ip}/sort`, {
                        idPerso,
                        nomSort,
                        descriptionSort,
                        effetSort,
                        coutSort,
                        niveausort
                    }, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    });
                }
                setNomSort("");
                setDescriptionSort("");
                setEffetSort("");
                setCoutSort("");
                setNiveauSort(1);
                fetchPersonnage();
                setModif(false);
                setOpen(false);
            } catch (error) {
                console.error('Erreur:', error);
            }
        }
    };


    return (
        <div className="modal-overlay" >
            <div className='modal_flex' ref={wrapperRef}>
                <div className="close" onClick={() => { setOpen(false); setModif(false) }}>
                    <Close></Close>
                </div>
                <div className="flex">
                    <span className='titleModal margin_1em_LR  padding_1em_top pct-60'>Nom du Sort</span>
                    <span className='titleModal margin_1em_LR  padding_1em_top'>LvL</span>
                </div>
                <div className="flex">
                    <input
                        type="text"
                        value={nomSort}
                        onChange={e => setNomSort(e.target.value)}
                        placeholder="Nom du Sort"
                        className='titleModal modal_bloc pct-60 border_1px_black input-transparent'
                    />
                    <input type="number"
                        className="margin_1em border_1px_black input-transparent"
                        value={niveausort}
                        onChange={e => setNiveauSort(e.target.value)}
                        min={1}
                        max={100}
                    />
                </div>
                <span className='titleModal margin_1em_LR pct-90'>Description du Sort</span>
                <textarea
                    type="text"
                    value={descriptionSort}
                    onChange={e => setDescriptionSort(e.target.value)}
                    placeholder="Description du Sort"
                    className='pct-90 modal_bloc height_10vh border_1px_black input-transparent'
                />

                <span className='titleModal margin_1em_LR pct-90'>Effet du Sort</span>
                <input
                    type="text"
                    value={effetSort}
                    onChange={e => setEffetSort(e.target.value)}
                    placeholder="Effet du Sort"
                    className='modal-corp pct-90 modal_bloc border_1px_black input-transparent'
                />

                <span className='titleModal margin_1em_LR pct-90'>Coût du Sort</span>
                <input
                    type="number"
                    value={coutSort}
                    onChange={e => setCoutSort(e.target.value)}
                    placeholder="Cout du Sort"
                    className='pct-90 modal_bloc modal_bloc border_1px_black input-transparent'
                />

                <button onClick={handleSubmit} className='pct-90 modal_bloc button-large'>Enregistrer</button>
            </div>
        </div>
    );
}

export default ModalNouveauSort;
